import React, { useEffect, useRef } from "react";
import { useOnClickOutside } from "../../hooks/useOnClickOutside";

type Props = {
  dropdownIsOpen: boolean;
  setDropdownIsOpen: (val: boolean) => void;
  btnContent: React.ReactNode;
  dropdownContent: React.ReactNode;
  dropdownClasses?: string;
  btnClasses?: string;
  transitionDuration?: number; // ms
};

export const Dropdown: React.FC<Props> = (props) => {
  const {
    dropdownIsOpen,
    setDropdownIsOpen,
    btnContent,
    dropdownContent,
    dropdownClasses,
    btnClasses,
    transitionDuration = 200,
  } = props;

  const ref = useRef(null);
  useOnClickOutside(ref, () => setDropdownIsOpen(false));

  const toggleDropdown = () => {
    setDropdownIsOpen(!dropdownIsOpen);
  };

  const [isEmptyContent, setIsEmptyContent] = React.useState(true);
  const content = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const children = content.current?.querySelectorAll("*");
    // check if have any text in them:
    let isEmpty = true;
    children?.forEach((child) => {
      if (child.textContent?.trim() !== "") isEmpty = false;
    });

    if (isEmpty) setIsEmptyContent(true);
    else setIsEmptyContent(false);
  }, [dropdownIsOpen, dropdownContent]);

  return (
    <div
      className="relative dropdown-box"
      ref={ref}
      style={{
        // hide it when the content is empty:
        display: isEmptyContent ? "none" : "block",
        visibility: isEmptyContent ? "hidden" : "visible",
        opacity: isEmptyContent ? 0 : 1,
      }}
    >
      <button onClick={toggleDropdown} className={btnClasses}>
        {btnContent}{" "}
        {dropdownIsOpen ? (
          <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.99854 0.53808L0.0292969 6.50732L0.983892 7.46191L5.99988 2.44592L11.0159 7.46191L11.9705 6.50732L6.00123 0.53808L5.99988 0.539427L5.99854 0.53808Z"
              fill="#2D2926"
            />
          </svg>
        ) : (
          <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.99951 6.96168L11.9687 0.992437L11.0142 0.0378417L5.99816 5.05383L0.982171 0.0378408L0.0275764 0.992436L5.99682 6.96168L5.99816 6.96033L5.99951 6.96168Z"
              fill="#2D2926"
            />
          </svg>
        )}
      </button>
      <div
        className={
          dropdownIsOpen
            ? `dropdown-list white-bg overflow-hidden transition-all open ${dropdownClasses}`
            : `dropdown-list white-bg overflow-hidden transition-all ${dropdownClasses}`
        }
      >
        <div className="dropdown-list-content" ref={content}>
          {dropdownContent}
        </div>
      </div>
    </div>
  );
};
